module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_FI-c6eee64863f34e55acde4fb8f0d68d6a.svg";